import React from 'react';

export default styles => Component => {
  function WrappedComponent(props) {
    const classes = styles();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component classes={classes} {...props} />;
  }

  return WrappedComponent;
};
